const liczbaOsi = { t: 'Liczba osi', type: 'range', name: 'liczba-osi' }
export default liczbaOsi